var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "logins-wrapper" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("img", {
        staticClass: "goback",
        attrs: { src: require("../../../static/images/goback.png"), alt: "" },
        on: { click: _vm.goBack }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "psd_guid" }, [_vm._v("密码登录")]),
      _vm._v(" "),
      _c("div", { staticClass: "box right" }, [
        _c("div", { staticClass: "name" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.user_name,
                expression: "user_name"
              }
            ],
            attrs: {
              placeholder: "手机号",
              type: "number",
              name: "user_name",
              id: "tel"
            },
            domProps: { value: _vm.user_name },
            on: {
              keyup: _vm.checkIfCanLogin,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.user_name = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pass" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.user_psd,
                expression: "user_psd"
              }
            ],
            attrs: {
              placeholder: "密码",
              type: "password",
              name: "password",
              id: "pass"
            },
            domProps: { value: _vm.user_psd },
            on: {
              keyup: _vm.checkIfCanLogin,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.user_psd = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "r-bot" }, [
          _c(
            "button",
            {
              staticClass: "login",
              class: { disabled: _vm.disabledFlag },
              attrs: { id: "login", disabled: _vm.disabledFlag },
              on: { click: _vm.login }
            },
            [_vm._v("登录\n        ")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "usual_problem" }, [
            _c("span", { on: { click: _vm.code_login } }, [
              _vm._v("验证码登录/注册")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "agreement" }, [
      _vm._v("登录即代表同意\n      "),
      _c(
        "a",
        {
          staticClass: "error_msg",
          attrs: {
            href:
              "http://www.eoffcn.com/help/agreements/offcnapp_user_agreement.html"
          }
        },
        [_vm._v("《用户协议》")]
      ),
      _vm._v("和\n      "),
      _c(
        "a",
        {
          staticClass: "error_msg",
          attrs: {
            href:
              "http://www.eoffcn.com/help/agreements/offcnapp_privacy_policy.html"
          }
        },
        [_vm._v("《隐私政策》")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef1bafe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef1bafe8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/login.vue
// module id = null
// module chunks = 